module.exports = __webpack_public_path__ + "img/home active.877f45d8.svg";